import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { toTitleCase } from '@/classes/SubmissionStatuses/statusUtils'
import {
	type OapSubmissionStatus,
	type SubmissionAction,
} from '@/classes/SubmissionStatuses/types'

export abstract class BaseOapStatus implements StatusObject {
	submissionStatus: OapSubmissionStatus

	constructor(submissionStatus: OapSubmissionStatus) {
		this.submissionStatus = submissionStatus
	}

	getVendorName() {
		return 'OAP'
	}

	getUpdatedAt() {
		return this.submissionStatus.updatedAt
	}

	getActions(): Array<SubmissionAction> {
		return []
	}

	getStatusText() {
		return toTitleCase(this.submissionStatus.status)
	}

	getToolTipText() {
		return {
			title: this.getVendorName() + ' ' + this.getStatusText(),
			body: '',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.INACTIVE
	}
}
